/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { Solids } from '@sick-davinci/glow';
import { Shape } from './CrownShapeCap';
import { CrownTransform } from '../../CrownTransform';
import { CrownShape } from './CrownShape';
let Shape3DBox = class Shape3DBox extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        CrownTransform.copyMatrix(shape.pose, this);
        const geometry = Solids.createBox(shape.sizeX, shape.sizeY, shape.sizeZ);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration);
        this.addOutline(geometry, decoration);
    }
    format() {
        const { source, t, r, s, Matrix } = this.transformPose();
        return {
            sizeX: s.x * source.sizeX,
            sizeY: s.y * source.sizeY,
            sizeZ: s.z * source.sizeZ,
            pose: {
                Type: r.length() > 0 ? 'RIGID' : t.length() > 0 ? 'TRANSLATION' : 'IDENTITY',
                Matrix,
            },
        };
    }
};
Shape3DBox = tslib_1.__decorate([
    Shape('Shape3D.Box'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DBox);
export { Shape3DBox };
//# sourceMappingURL=Shape3DBox.js.map